import "./App.css";
import { BrowserRouter, Route, Routes, Outlet } from "react-router";
import { useContext, useEffect } from 'react'
import { EmpdContext } from './Context'

//import msalInstance from './Components/Msal/Msal'
import Welcome from "./Pages/Welcome";
import Leadership from "./Pages/Leadership";
import Registered from "./Pages/Registered";
import Editor from "./Pages/Editor";
import ClinicalTrials from "./Pages/Registered/Components/PatientDashboard/Components/ClinicalTrials";
import Resources from "./Pages/Registered/Components/PatientDashboard/Components/Resources";
import Navigation from "./Components/Navigation";
import AuthErrorModal from "./Components/AuthErrorModal";
import { winshipBlue, winshipWhite } from "./Assets/Images";
import Footer from "./Components/Footer";
import {
  APPLICATION_ROUTES,
  FOOTER_LINKS,
  PRIMARY_LINK,
} from "./Consts/navigation";
import { FOOTER_COPY } from "./Consts/siteVerbiage";
import { createUseStyles } from "react-jss";
import TheInitiative from "./Pages/TheInitiative";
import ThankYouForRegistering from "./Pages/ThanksForRegistering";
import PatientPortalRegistration from "./Pages/PatientPortalRegistration";
import Logout from "./Components/Logout"
import ProviderDashboard from "./Components/Provider/Dashboard"
import ProviderDocuments from "./Components/Provider/Documents"
import ProviderResources from "./Components/Provider/Resources"
import NoMatch from "./Components/NoMatch"
import ProviderRegistration from "./Components/Provider/ProviderRegistration";
import AuthCallback from "./Components/AuthCallback";

interface Props {
    classes?: any,
}

const useStyles = createUseStyles({
  root: {
    display: "flex",
    minHeight: "calc(100vh - 119px)",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  heroButton: {
    alignSelf: "flex-start",
    marginTop: "20px",
    display: "inline-block",
  },
  dashboardWrapper: {
    background: "#f8f8f8",
    height: "100%",
    padding: "50px 0px",
  },
  dashboardContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dashboardCard: {
    flexBasis: "44.5%",
  },
});

const RootLayout = ({ classes }: Props) => {
	return (
		<div>
			<AuthErrorModal />
			<Navigation
				links={APPLICATION_ROUTES}
                primaryLink={PRIMARY_LINK}
                logo={winshipBlue}
                inverse
            />
            <div className={classes.root}>
				<Outlet />
			</div>
			<Footer
            	links={FOOTER_LINKS}
                logo={winshipWhite}
                copyLabel={FOOTER_COPY}
            />
		</div>
	)
}

const Layout = ({ classes }: Props) => {
	return (
		<div>
		  <Outlet />
		</div>
	)
}

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("Context Provider Not Found for EMPD")
    } 

    return context
}

const App: React.FC = () => {
  const { fetchNamespace } = useMyContext()

  const classes = useStyles();

  useEffect(() => {
    fetchNamespace()
  }, [])

  const pathname = window.location.pathname
  if( pathname.startsWith('/api/') ) {
	return null
  }

  const render = () => {
  return (
            <BrowserRouter>
                <Routes>
					<Route path="/" element={<RootLayout classes={classes} />} >
                        <Route index element={<Welcome />} />
   	                    <Route path="behind-the-initiative" element={<TheInitiative />} />
       	                <Route path="leadership" element={<Leadership />} />
           	            <Route
               	          path="thanks-for-registering"
                   	      element={<ThankYouForRegistering />}
                        />
   	                    <Route
       	                  path="patient-portal-registration"
           	              element={<PatientPortalRegistration />}
               	        />
                   	    <Route
                       	  path="registered"
                          element={<Registered />}
   	                    />
       	                <Route
           	              path="resources"
               	          element={<Resources classes={classes} />}
                   	    />
                       	<Route
                          path="clinical_trials"
   	                      element={<ClinicalTrials classes={classes} />}
       	                />
           	            <Route
               	          path="editor"
                   	      element={<Editor classes={classes} />}
                       	/>
   	                    <Route
       	                  path="logout"
           	              element={<Logout />}
               	        />
   	                    <Route
       	                  path="auth_callback"
           	              element={<AuthCallback />}
               	        />
   	                    <Route
       	                  path="ebf332ae-8a0b-409d-a03e-b60b8bd1339d"
           	              element={<ProviderRegistration />}
               	        />
						<Route
							path="provider"
							element={<Layout classes={classes} />}
						>				
							<Route
								path="dashboard"
								element={<ProviderDashboard />}
							/>	
							<Route
								path="documents"
								element={<ProviderDocuments />}
							/>	
                       		<Route
                   	    	  path="resources"
                	          element={<ProviderResources />}
   	        	            />
       	                	<Route
        	                  path="logout"
   	        	              element={<Logout />}
       	        	        />
						</Route>
						<Route path="*" element={<NoMatch />} />
					</Route>
                </Routes>
            </BrowserRouter>
  );
  }

  return <EmpdContext.Consumer>{() => render() }</EmpdContext.Consumer>
}

export default App;
